import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import autoFocus from '../lib/hoc/autoFocus';

class Textarea extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
    }

    updateHeight(textareaNode) {
        if (this.props.isExpandable && textareaNode.scrollHeight > textareaNode.clientHeight) {
            $(textareaNode).innerHeight(textareaNode.scrollHeight);
        } else if (this.props.isCollapsible) {
            this.initialiseHeight(textareaNode);
            $(textareaNode).innerHeight(textareaNode.scrollHeight);
        }
    }

    initialiseHeight(textarea) {
        $(textarea).outerHeight(this.props.minHeight || 'auto');
    }

    componentDidMount() {
        const textarea = ReactDOM.findDOMNode(this);
        this.initialiseHeight(textarea);
        this.applyResizeBehaviors(textarea);
        this.updateHeight(textarea);
    }

    componentDidUpdate() {
        var textarea = ReactDOM.findDOMNode(this);
        this.updateHeight(textarea);
    }

    // In WebKit all textareas cannot be resized to under 150px. In Firefox they can be resized to 50px.
    // This takes over browser resizing as a workaround.
    applyResizeBehaviors(textarea) {
        var resizableStart = function() {
            textarea.originalW = textarea.clientWidth;
            textarea.originalH = textarea.clientHeight;
            textarea.onmousemove = resizableCheck;
            textarea.onmouseup = resizableEnd;
            textarea.onmouseout = resizableEnd;
        };

        var resizableCheck = function(e) {
            if (
                textarea.clientWidth !== textarea.originalW ||
                textarea.clientHeight !== textarea.originalH
            ) {
                textarea.originalX = e.clientX;
                textarea.originalY = e.clientY;
                textarea.onmousemove = resizableMove;
            }
        };

        var resizableMove = function(e) {
            var newW = textarea.originalW + e.clientX - textarea.originalX;
            var newH = textarea.originalH + e.clientY - textarea.originalY;
            var resize = textarea.style.resize;

            if (newW < textarea.originalW && ['horizontal', 'both'].indexOf(resize) > -1) {
                textarea.style.width = newW + 'px';
            }

            if (newH < textarea.originalH && ['vertical', 'both'].indexOf(resize) > -1) {
                textarea.style.height = newH + 'px';
            }
        };

        var resizableEnd = function() {
            textarea.onmousemove = null;
            textarea.onmouseout = null;
            textarea.onmouseup = null;
        };

        textarea.onmouseover = resizableStart;
    }

    handleChange(e) {
        this.props.onChange(e);
    }

    handleFocus(e) {
        this.props.onFocus(e);

        // If there is content in the textarea, move cursor to end of textarea on focus
        if (this.props.value.length > 0) {
            ReactDOM.findDOMNode(this).setSelectionRange(
                this.props.value.length,
                this.props.value.length
            );
        }
    }

    render() {
        var textareaStyle = {
            resize: this.props.resize,
            minHeight: this.props.minHeight,
            maxHeight: this.props.maxHeight,
            boxSizing: 'border-box',
        };

        return (
            <textarea
                onKeyDown={this.props.onKeyDown}
                onKeyUp={this.props.onKeyUp}
                style={textareaStyle}
                disabled={this.props.isDisabled}
                onChange={this.handleChange}
                onFocus={this.handleFocus}
                onBlur={this.props.onBlur}
                value={this.props.value}
                placeholder={this.props.placeholder}
                className="input-text input-width--max"
            />
        );
    }
}

Textarea.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    minHeight: PropTypes.number,
    maxHeight: PropTypes.number,
    isExpandable: PropTypes.bool,
    isCollapsible: PropTypes.bool,
    isDisabled: PropTypes.bool,
    resize: PropTypes.oneOf(['none', 'both', 'horizontal', 'vertical']),
    onKeyDown: PropTypes.func,
    onKeyUp: PropTypes.func,
    placeholder: PropTypes.string,
};

Textarea.defaultProps = {
    value: '',
    minHeight: 0,
    isExpandable: false,
    isCollapsible: false,
    resize: 'vertical',
    onKeyDown() {},
    onKeyUp() {},
    onFocus() {},
    onBlur() {},
    onChange() {},
    placeholder: '',
};

export default autoFocus(Textarea);



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Textarea.jsx